var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 20.27C8.46009 20.27 5.5791 18.9258 5.5791 17.2734C5.5791 16.0748 7.09713 14.9986 9.4473 14.5234C10.2405 15.5598 11.0929 16.5494 12.0003 17.4875C12.9079 16.5499 13.7601 15.5602 14.5525 14.5234C16.9035 14.9995 18.4215 16.0791 18.4215 17.2734C18.4215 18.9258 15.5414 20.27 12.0003 20.27Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.9,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1372 9.13698C17.1372 12.3048 12.0003 17.4846 12.0003 17.4846C12.0003 17.4846 6.86328 12.3073 6.86328 9.13698C6.86328 7.77456 7.40447 6.46793 8.36784 5.50456C9.33121 4.54119 10.6378 4 12.0003 4C13.3627 4 14.6693 4.54119 15.6327 5.50456C16.596 6.46793 17.1372 7.77456 17.1372 9.13698Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.4844V10.2622M11 10.2622V7.48438H12.7259C13.2092 7.48438 13.6602 7.72708 13.9264 8.13044L13.9681 8.19363C14.2855 8.67449 14.2582 9.30479 13.9005 9.75645V9.75645C13.6475 10.0759 13.2624 10.2622 12.8549 10.2622H11Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.0845ac3565926f2fd6a7722f8e377e20.svg";
export { ForwardRef as ReactComponent };